import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <Box className="app">
      <main className="content" style={{ width: "100%" }}>
        <Outlet />
      </main>
    </Box>
  );
};

export default AuthLayout;
